import { Table } from "@radix-ui/themes";
import { Skeleton } from "../elements.js";

export function SkeletonTable({
  numRows,
  columns,
}: {
  numRows: number;
  columns: Table.ColumnHeaderCellProps[];
}) {
  return (
    <Table.Root>
      <Table.Header>
        <Table.Row>
          {columns.map((column, index) => (
            <Table.ColumnHeaderCell key={index}>
              <Skeleton>{column.children}</Skeleton>
            </Table.ColumnHeaderCell>
          ))}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {Array.from({ length: numRows }).map((_, index) => (
          <Table.Row key={index}>
            {columns.map((column, index) => (
              <Table.Cell key={index}>
                <Skeleton>{column.children}</Skeleton>
              </Table.Cell>
            ))}
          </Table.Row>
        ))}
      </Table.Body>
    </Table.Root>
  );
}
